import { render, staticRenderFns } from "./WidgetRating.vue?vue&type=template&id=08c389e9"
import script from "./WidgetRating.vue?vue&type=script&lang=js"
export * from "./WidgetRating.vue?vue&type=script&lang=js"
import style0 from "./WidgetRating.vue?vue&type=style&index=0&id=08c389e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports